import { ReactNode } from "react";
import * as Color from "capitalrx-components-2.0/lib/general/Color";
import styled from "styled-components";

/** The `Breadcrumbs` component properties. */
export interface BreadcrumbsProps {

  /** The component children. */
  readonly children?: ReactNode;
}

const Root = styled.div`
  display: flex;
  font-size: 10px;
  line-height: 16px;
  margin-bottom: 20px;

  &>.item {
    display: block;
    text-decoration: none;
    color: ${Color.toString(Color.DarkGrey[400])};
    margin-right: 11px;

    &:is(span) {
      cursor: default;
    }

    &:is(a:hover) {
      text-decoration: underline;
    }
  }

  &>.separator {
    margin-right: 11px;
    width: 6px;
  }
`;

/** Component that renders out the set of provided breadcrumbs. */
export const Breadcrumbs = (props: BreadcrumbsProps): ReactNode => {
  const { children } = props;

  return <Root className="breadcrumbs">{children}</Root>;
};
